import { useDispatch } from 'react-redux';
import {Box, Button, CircularProgress, Grid, TextField, useMediaQuery, useTheme} from '@mui/material';
import { Ring } from 'entities/ring';
import {User, userActions, UserRole, userSelector, UserStatus} from 'entities/user';
import { weddingActions, weddingSelector } from 'entities/wedding';
import { VDayLogo } from 'pages/home/ui/Icons/VDayLogo';
import { COLOR_WHITE, uiSelector } from 'shared/config';
import { useShallowSelector } from 'shared/hooks';
import {EngagementType, SexType} from 'shared/types';
import { Typography } from 'shared/ui/components';
import {checkRequestStatusEquality, pinata} from 'shared/utils';
import { useTranslation } from 'react-i18next';
import {FianceCodeContainer} from "../../features/connection/containers";
import {MatchContainer} from "../../features/match";
import {Stack} from "@mui/system";
import {Controller} from "react-hook-form";
import {useCallback, useEffect, useRef, useState} from 'react'
import {AgreementCheckbox, GenderSelectBlock, WeddingTypeBlock} from "../../features/connection/ui";
import {modalActions, ModalType} from "../../entities/modal";
import Poster from "../../shared/assets/poster.png";
import Video from "../../shared/assets/video/ring.mp4";

export const VowsSuccess = () => {
    const { t, i18n } = useTranslation();
    const dispatch = useDispatch();
    const theme = useTheme();
    const isDownMdLayout = useMediaQuery(theme.breakpoints.down('md'));

    const uiState = useShallowSelector(uiSelector.getUI);
    const { members } = useShallowSelector(weddingSelector.getWedding);
    const { id: userId, sex: userSex } = useShallowSelector(userSelector.getUser);
    const isUserMan = userSex === SexType.man;
    const isStart = true;

    const currentUser = members.find(({ user: { id } }) => id === userId);
    const partner = members.find(({ user: { id } }) => id !== userId);

    const currentUserDisplayData = {
        status: UserStatus.You,
        firstName: currentUser?.user.firstName || '',
        lastName: currentUser?.user.lastName || '',
        avatar: currentUser?.user.profileImage,
        ringImg: currentUser?.token?.meta?.imageUrl || '',
    };

    const partnerDisplayData = {
        status: partner?.user.isOnline ? UserStatus.Online : UserStatus.Offline,
        firstName: partner?.user.firstName || '',
        lastName: partner?.user.lastName || '',
        avatar: partner?.user.profileImage,
        ringImg: partner?.token?.meta?.imageUrl || '',
    };

    const firstUserDisplayData = !isUserMan ? currentUserDisplayData : partnerDisplayData;
    const secondUserDisplayData = isUserMan ? currentUserDisplayData : partnerDisplayData;

    const isConfirmPreviewRingsLoading = checkRequestStatusEquality(uiState[weddingActions.confirmPreviewRings?.type]);

    const [selectedFile, setSelectedFile] = useState('');
    const [selectedFileUpload, setSelectedFileUpload] = useState(false);
    const [selectedFileUploadOk, setSelectedFileUploadOk] = useState(false);
    const [selectedText, setSelectedText] = useState('');
    const [sendVows, setSendVows] = useState(false);

    const [showNextPage, setShowNextPage] = useState(true);


    const handleFileChange = async (e:any) => {
        if (e.target.files && e.target.files[0]) {
            try {
                setSelectedFileUpload(true);
                const upload = await pinata.upload.file(e.target.files[0]);
                const ipfsUrl = await pinata.gateways.convert(upload.IpfsHash);
                setSelectedFile(ipfsUrl);
                setSelectedFileUpload(false);
                setSelectedFileUploadOk(true);
            } catch (error) {
                console.log(error);
            }
        }

    };

    const isUserWaiting = ((partner?.vows === null || partner?.vows === undefined) && sendVows);
    useEffect(() => {
        if (isUserWaiting) {
            dispatch(
                modalActions.openModal({
                    type: ModalType.Loading,
                    data: { title: t('ring_RingPrice_waiting') },
                }),
            );
        }
        return () => {
            dispatch(modalActions.closeModal());
        };
    }, [dispatch, isUserWaiting]);

    const handleNext = () => {
        setSendVows(true);
        dispatch(weddingActions.selectVows({videoUrl: selectedFile, text: selectedText}));
    };

    const videoRefsMan = useRef(null);
    const handleClickVideoMan = (index:any) => {
        if (videoRefsMan.current) {
            // @ts-ignore
            videoRefsMan.current.play();
        }
    };

    const handleChangeText = (event:any) => {
        setSelectedText(event.target.value);
    };
    const handleNextPage = () => {
        setShowNextPage(!showNextPage);
    };
    const handleVideoEnded = useCallback((event: React.SyntheticEvent<HTMLVideoElement, Event>) => {
        const video = event.currentTarget; // Get the video element
        video.pause();
        video.currentTime = video.duration;
    }, []);
    return showNextPage ? (
        <Grid container spacing={{ xs: 2, md: 7 }} justifyContent="center">
            <Grid item container xs={12} paddingTop="50px!important" justifyContent="center" flexDirection="column" alignItems="center">
                <Typography variant="h3" sx={{
                    fontSize: '36px',
                    fontWeight: '700',
                    lineHeight: '0.95',
                    textAlign: 'center',
                    fontFamily: 'Montserrat, sans-serif'
                }} className="center">{t('vowsSuccess_title1')}</Typography>
            </Grid>
            <Grid item container xs={12} paddingTop="10px!important" alignItems="center" justifyContent="center">
                <Typography variant="h2"  sx={{
                    marginTop: '12px',
                    fontFamily: 'Tektur, serif',
                    fontSize: { xs: '18px!important', md: '24px'},
                    fontWeight: '400',
                    background: 'radial-gradient(circle, #2df6de 20%, #3c5dfe 100%)',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                    textSlign: 'center',
                    marginBottom: '20px !important'
                }}  className="center">{t('vowsSuccess_title2')}</Typography>
            </Grid>
            <Grid
                item
                container
                xs={12}
                direction={{ xs: 'column', md: 'row' }}
                spacing={2}
                justifyContent="center"
                alignItems="center"
            >
                <Grid item >
                    <Ring img={isDownMdLayout ? partnerDisplayData.ringImg : firstUserDisplayData.ringImg} size='small' simple noBorder />
                    {/*<video
                        autoPlay
                        muted
                        playsInline
                        onEnded={handleVideoEnded}
                        style={{ width: '100%', height: 'auto', objectFit: 'cover', display: 'block' }}
                        preload="auto"
                        src={Video}
                        >
                    </video>*/}
                </Grid>
            </Grid>
            <Grid item container xs={11} md={7} justifyContent='center'>
                <Typography variant="h4" fontSize="18px" textAlign="center" >
                    {t('vowsSuccess_desc')}
                </Typography>
            </Grid>
            <Grid item container xs={12} justifyContent='center'>
                <Button variant="contained" onClick={handleNextPage} sx={{ minWidth: 189, marginBottom: '40px' }}>
                    {isConfirmPreviewRingsLoading ? <CircularProgress size={30} sx={{ color: COLOR_WHITE }} /> : t('Next')}
                </Button>
            </Grid>
        </Grid>
    ) : (
        <Grid container spacing={{ xs: 2, md: 7 }} justifyContent="center">
            <Grid item container xs={12} paddingTop="50px!important" justifyContent="center" flexDirection="column" alignItems="center">
                <Typography variant="h3" sx={{
                    fontSize: '36px',
                    fontWeight: '700',
                    lineHeight: '0.95',
                    textAlign: 'center',
                    fontFamily: 'Montserrat, sans-serif'
                }} className="center">{t('vowsSuccess_title1')}</Typography>
            </Grid>
            <Grid item container xs={12} paddingTop="10px!important" alignItems="center" justifyContent="center">
                <Typography variant="h2"  sx={{
                    marginTop: '12px',
                    fontFamily: 'Tektur, serif',
                    fontSize: { xs: '18px!important', md: '24px'},
                    fontWeight: '400',
                    background: 'radial-gradient(circle, #2df6de 20%, #3c5dfe 100%)',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                    textAlign: 'center',
                    marginBottom: '20px !important'
                }}  className="center">{t('vowsSuccess_title2')}</Typography>
            </Grid>
            {/* <Grid
                item
                container
                xs={12}
                direction={{ xs: 'column', md: 'row' }}
                flexWrap={{ xs: 'nowrap', md: 'wrap' }}
                spacing={2}
                justifyContent="center"
                alignItems="center"
            >

                <Grid item container xs={12} md={12} justifyContent='center' >
                    <Typography variant="h4" sx={{
                        marginTop: '12px',
                        fontFamily: 'Montserrat, sans-serif',
                        fontSize: '18px',
                        fontWeight: '700',
                        textAlign: 'center',
                    }}>{t('vowsSuccess_title3')}</Typography>
                </Grid>
                <Grid item >
                    <Ring img={isDownMdLayout ? partnerDisplayData.ringImg : firstUserDisplayData.ringImg} size='small' simple noBorder />
                    <video
                        autoPlay
                        muted
                        playsInline
                        onEnded={handleVideoEnded}
                        style={{ width: '100%', height: 'auto', objectFit: 'cover', display: 'block' }}
                        preload="auto"
                        src={Video}
                    >
                    </video>
                </Grid>
            </Grid>*/}
            <Grid item container xs={11} md={7} justifyContent='center' sx={{maxWidth: '600px', paddingLeft: '0'}}>
                <Grid item container xs={12} md={12} justifyContent='center' flexDirection='column'>
                    <Typography variant="h4" sx={{
                        marginTop: '12px',
                        fontFamily: 'Montserrat, sans-serif',
                        fontSize: '18px',
                        fontWeight: '700',
                        textAlign: 'center',
                        margin: '20px 0 0 0'
                    }}>{t('vowsSuccess_title4')}</Typography>
                    <Typography variant="h4" sx={{
                        marginTop: '12px',
                        fontFamily: 'Montserrat, sans-serif',
                        fontSize: '16px',
                        fontWeight: '500',
                        color: '#4f4f4f',
                        textAlign: 'center',
                        margin: '0 0 20px 0'
                    }}>{t('vowsSuccess_title4_sub')}</Typography>
                </Grid>
                <Grid item container xs={12} md={12} justifyContent='center' display={selectedFileUploadOk ? 'block': 'none'}>
                    <Stack sx={{
                        maxWidth: '356px',
                        margin: '20px auto'
                    }}>
                        <video
                            onClick={handleClickVideoMan}
                            ref={videoRefsMan}
                            src={selectedFile}
                            muted
                            loop
                            playsInline
                            controls
                            poster={Poster}
                        ></video>
                    </Stack>
                </Grid>
                <Grid item container xs={8} md={5} sx={{display: 'none'}}>
                    <TextField
                        label={t('vowsSuccess_input')}
                        placeholder={t('vowsSuccess_input')}
                        sx={{ color: '#fff'}}
                        className={'visibleLabel'}
                        value={selectedFile}
                        disabled
                    />
                </Grid>
                <Grid item container xs={4} md={3} justifyContent="center" flexDirection="column" alignItems="center">
                    <Button
                        variant="contained"
                        component="label"
                        htmlFor="contained-button-file"
                        onClick={handleFileChange}
                    >
                        {selectedFileUpload ? <CircularProgress size={30} sx={{ color: COLOR_WHITE }} /> : t('Upload')}
                        <TextField
                            sx={{ display: "none" }}
                            id="contained-button-file"
                            type="file"
                            onChange={handleFileChange}
                            hidden={true}
                        />
                    </Button>
                </Grid>
            </Grid>
            <Grid item container xs={12} md={7} justifyContent='center' pt={'30px!important'} flexDirection='column'>
                <Typography variant="h4" sx={{
                    fontSize: '16px',
                    textAlign: 'center'
                }}>{t('vowsSuccess_orand_title')}</Typography>
                <Typography variant="h4" sx={{
                    fontSize: '16px',
                    textAlign: 'center',
                    fontWeight: '500',
                    color: '#4f4f4f',
                }}>{t('vowsSuccess_orand')}</Typography>
            </Grid>
            <Grid item container xs={11} md={7} justifyContent='center' pt={'30px!important'}>
                <Grid item container xs={12} md={8}>
                    <TextField
                        label={t('vowsWrite')}
                        placeholder={t('vowsWrite')}
                        sx={{ color: '#fff'}}
                        value={selectedText}
                        onChange={handleChangeText} // Обработчик изменений
                        multiline
                        maxRows={7}
                    />
                </Grid>
            </Grid>
            <Grid item container xs={12} justifyContent='center'>
                <Button variant="contained" onClick={handleNext} sx={{ minWidth: 189, textTransform: 'none', marginBottom: '40px' }}>
                    {isConfirmPreviewRingsLoading ? <CircularProgress size={30} sx={{ color: COLOR_WHITE }} /> : t('vowsCeremony')}
                </Button>
            </Grid>
        </Grid>
    );
};
